import {
    Activity,
    ArrowRightLeft,
    BadgeEuro,
    Banknote,
    Bell,
    Building2,
    CalendarCheck,
    CalendarClock,
    CalendarDays,
    CalendarRange,
    CalendarX,
    Circle,
    DollarSign,
    Dumbbell,
    FileBarChart,
    FileText,
    GraduationCap,
    HelpCircle,
    MonitorSmartphone,
    PartyPopper,
    Receipt,
    ReceiptText,
    ShieldAlert,
    Tag,
    Ticket,
    Trophy,
    UserCog,
    Users,
    UsersRound,
    Wallet,
    Warehouse,
    type LucideIcon,
} from 'lucide-react';

/**
 * Iconos del sidebar. Son los mismos (lucide) y con la misma asignación que el
 * sidebar de sporttia-competitions, para que los dos menús se lean igual.
 */
const ICON_BY_MENU_ID: Record<string, LucideIcon> = {
    home: Building2,
    users: UserCog,
    bookings: CalendarCheck,
    events: PartyPopper,
    activities: Dumbbell,
    accountability: Wallet,
    scReports: FileBarChart,
    competitions: Trophy,
    help: HelpCircle,
    notifications: Bell,
};

/** Iconos de submenú, por `path` (que es único en menus.json). */
const ICON_BY_SUBMENU_PATH: Record<string, LucideIcon> = {
    files: FileText,
    devices: MonitorSmartphone,
    busySchedules: CalendarX,
    facilities: Warehouse,
    rates: DollarSign,
    freeSchedules: CalendarClock,
    discounts: Tag,
    mships: Users,
    groups: UsersRound,
    bonos: Ticket,
    bookings: CalendarDays,
    bookingSchedules: CalendarRange,
    restrictions: ShieldAlert,
    activities: Activity,
    teachers: GraduationCap,
    payments: Banknote,
    charges: BadgeEuro,
    transactions: ArrowRightLeft,
    remittences: Receipt,
    scTickets: ReceiptText,
};

function menuIconFor(id: string): LucideIcon {
    // Las entradas promovidas a primer nivel llevan el path como id, así que se
    // busca también en el mapa de submenús.
    return ICON_BY_MENU_ID[id] ?? ICON_BY_SUBMENU_PATH[id] ?? Circle;
}

function submenuIconFor(path?: string): LucideIcon {
    return (path && ICON_BY_SUBMENU_PATH[path]) || Circle;
}

interface MenuIconProps {
    id: string;
    className?: string;
}

export function MenuIcon({
    id,
    className = 'h-4 w-4',
}: MenuIconProps): React.ReactElement {
    const Icon = menuIconFor(id);

    return <Icon className={className} />;
}

interface SubmenuIconProps {
    path?: string;
    className?: string;
}

export function SubmenuIcon({
    path,
    className = 'h-4 w-4',
}: SubmenuIconProps): React.ReactElement {
    const Icon = submenuIconFor(path);

    return <Icon className={className} />;
}
